import { useState, useEffect } from 'react';
import { Table, DatePicker, Select, Button, Modal, Form, Input, Tag, message } from 'antd';
import { getData, createData, updateData, deleteData } from '../api/api';
import { SearchOutlined } from "@ant-design/icons";
import { useTranslation } from 'react-i18next';

const { Search } = Input;

const Users = ({ isAdmin }) => {
    const { t } = useTranslation();
    const [data, setData] = useState([]);
    const [merchants, setMerchants] = useState([]);
    const [terminals, setTerminals] = useState([]);
    const [loading, setLoading] = useState(false);
    const [pagination, setPagination] = useState({ current: 1, pageSize: 10 });
    const [filters, setFilters] = useState({});
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [form] = Form.useForm();

    const columns = [
        {
            title: t('users.index'),
            key: 'index',
            width: 60,
            render: (_, __, index) =>
                index + 1 + (pagination.current - 1) * pagination.pageSize,
        },
        { title: t('users.fullname'), dataIndex: 'fullname', key: 'fullname', width: 200 },
        { title: t('users.phone'), dataIndex: 'phone', key: 'phone', width: 150 },
        {
            title: t('users.status'),
            dataIndex: 'status',
            key: 'status',
            width: 100,
            render: (status) =>
                status === 0 ? <Tag color="green">{t('users.active')}</Tag> : <Tag color="red">{t('users.inactive')}</Tag>,
        },
        {
            title: t('users.terminals'),
            key: 'terminals',
            width: 200,
            render: (_, record) => {
                if (!record.terminals || Object.keys(record.terminals).length === 0) {
                    return '-';
                }
                const terminalNames = Object.values(record.terminals);
                return terminalNames.join(', ');
            }
        },
        {
            title: t('users.roles'),
            key: 'roles',
            width: 200,
            render: (_, record) => {
                if (!record.roles || record.roles.length === 0) {
                    return '-';
                }
                return record.roles.join(', ');
            }
        },
        { title: t('users.createdAt'), dataIndex: 'createdAt', key: 'createdAt', width: 180 },
        { title: t('users.updatedAt'), dataIndex: 'updatedAt', key: 'updatedAt', width: 180 },
    ];

    // if (isAdmin) {
    //     columns.push({
    //         title: t('users.actions'),
    //         key: 'actions',
    //         width: 200,
    //         render: (_, record) => (
    //             <>
    //                 <Button size="small" onClick={() => handleUpdate(record)}>
    //                     {t('users.edit')}
    //                 </Button>
    //                 <Button
    //                     size="small"
    //                     danger
    //                     onClick={() => handleDelete(record.id)}
    //                     style={{ marginLeft: 8 }}
    //                 >
    //                     {t('users.delete')}
    //                 </Button>
    //             </>
    //         ),
    //     });
    // }

    const fetchData = async () => {
        setLoading(true);
        try {
            const response = await getData(
                isAdmin
                    ? '/admin/dashboard/user-list-by-filter'
                    : '/merchant/dashboard/user-list-by-filter',
                {
                    page: pagination.current - 1,
                    size: pagination.pageSize,
                    status: -1,
                    ...filters,
                }
            );
            setData(response.data?.data?.content || []);
            setPagination({
                ...pagination,
                total: response.data?.data?.totalCount,
            });
        } catch (error) {
            console.error(error);
        }
        setLoading(false);
    };

    const getMerchants = async () => {
        try {
            const response = await getData(
                isAdmin
                    ? '/admin/dashboard/merchants-list-by-filter'
                    : '/merchant/dashboard/merchants-list-by-filter',
                {
                    page: 0,
                    size: 1000000,
                    status: -1,
                }
            );
            setMerchants(response.data?.data?.content || []);
        } catch (error) {
            console.error(error);
        }
    };

    const getTerminals = async () => {
        const merchantId = filters.merchantId;
        if (!isAdmin || merchantId) {
            try {
                const response = await getData(
                    isAdmin
                        ? '/admin/dashboard/terminal-list-by-filter'
                        : '/merchant/dashboard/terminal-list-by-filter',
                    {
                        page: 0,
                        size: 10000000,
                        status: -1,
                        merchantId: merchantId,
                    }
                );
                setTerminals(response.data?.data?.content || []);
            } catch (error) {
                console.error(error);
            }
        } else {
            setTerminals([]);
        }
    };

    useEffect(() => {
        fetchData();
        if (isAdmin && (!merchants || merchants.length === 0)) {
            getMerchants();
        }
    }, [pagination.current, pagination.pageSize, filters]);

    useEffect(() => {
        getTerminals();
    }, [filters.merchantId]);

    const handleTableChange = (newPagination) => {
        setPagination(newPagination);
    };

    const handleFilter = (values) => {
        setFilters(values);
        setPagination({ ...pagination, current: 1 });
    };

    const handleCreate = async (values) => {
        try {
            const response = await createData(
                '/admin/static-qr/default-create',
                {
                    ...values,
                    minAmount: values.minAmount * 100,
                    maxAmount: values.maxAmount * 100
                }
            );
            if (response?.data?.success && response?.data?.data) {
                message.success(t('users.successAdd'));
                fetchData();
                handleCancel();
            } else {
                alert(response?.data?.error?.text || t('users.errorAdd'));
            }
        } catch (error) {
            console.error(error);
            alert(t('users.errorAdd'));
            message.error(t('users.errorAdd'));
        }
    };

    const handleUpdate = async (record) => {
        // await updateData('/dashboard', record.id, record);
        // fetchData();
    };

    const handleDelete = async (id) => {
        // await deleteData('/dashboard', id);
        // fetchData();
    };

    const showModal = () => {
        setIsModalVisible(true);
    };

    const handleCancel = () => {
        setIsModalVisible(false);
        form.resetFields();
    };

    return (
        <div>
            <div
                style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    marginBottom: 16,
                }}
            >
                <h2 style={{ margin: 0 }}>{t('users.title')}</h2>
                {/*{isAdmin ? (*/}
                {/*    <Button type="primary" onClick={showModal}>*/}
                {/*        {t('users.add')}*/}
                {/*    </Button>*/}
                {/*) : (*/}
                {/*    ''*/}
                {/*)}*/}
            </div>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, marginBottom: 16 }}>
                {isAdmin ? (
                    <Select
                        style={{ width: 200 }}
                        defaultValue={null}
                        onChange={(value) => handleFilter({ ...filters, merchantId: value })}
                        size="middle"
                        placeholder={t('users.selectMerchant')}
                        showSearch
                        filterOption={(input, option) =>
                            option?.children?.toLowerCase().includes(input.toLowerCase())
                        }
                        allowClear
                        notFoundContent={t('users.notFound')}
                        dropdownStyle={{ zIndex: 9999 }}
                        getPopupContainer={(trigger) => trigger.parentNode}
                    >
                        <Select.Option value={null}>{t('users.allMerchants')}</Select.Option>
                        {merchants?.map((value) => (
                            <Select.Option key={value.id} value={value.id}>
                                {value.name}
                            </Select.Option>
                        ))}
                    </Select>
                ) : (
                    ''
                )}
                <Select
                    style={{ width: 200 }}
                    defaultValue={null}
                    onChange={(value) => handleFilter({ ...filters, terminalId: value })}
                    size="middle"
                    placeholder={t('users.selectTerminal')}
                    showSearch
                    filterOption={(input, option) =>
                        option?.children?.toLowerCase().includes(input.toLowerCase())
                    }
                    allowClear
                    notFoundContent={t('users.notFound')}
                    dropdownStyle={{ zIndex: 9999 }}
                    getPopupContainer={(trigger) => trigger.parentNode}
                    disabled={isAdmin ? !filters.merchantId : false}
                >
                    <Select.Option value={null}>{t('users.allTerminals')}</Select.Option>
                    {terminals?.map((value) => (
                        <Select.Option key={value.id} value={value.id}>
                            {value.name}
                        </Select.Option>
                    ))}
                </Select>
                <Search
                    placeholder={t('users.searchPlaceholder')}
                    allowClear
                    enterButton={<SearchOutlined />}
                    size="middle"
                    style={{ width: 300 }}
                    onSearch={(value) => handleFilter({ ...filters, search: value })}
                />
            </div>
            <Table
                columns={columns}
                dataSource={data}
                pagination={{
                    ...pagination,
                    showTotal: (total) => t('users.total', { total }),
                }}
                loading={loading}
                onChange={handleTableChange}
                rowKey="id"
                scroll={{ x: 'max-content' }}
            />
            <Modal
                title={t('users.addTitle')}
                visible={isModalVisible}
                onCancel={handleCancel}
                footer={null}
            >
                <Form form={form} onFinish={handleCreate} layout="vertical">
                    <Form.Item
                        label={t('users.terminalType')}
                        name="terminalType"
                        rules={[{ required: true, message: t('users.terminalTypeRequired') }]}
                        initialValue={"E-POS"}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        label={t('users.redirectUrl')}
                        name="redirectUrl"
                        rules={[{ required: true, message: t('users.redirectUrlRequired') }]}
                        initialValue={"https://qrpay.uz"}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        label={t('users.minAmount')}
                        name="minAmount"
                        rules={[{ required: true, message: t('users.minAmountRequired') }]}
                        initialValue={1000}
                    >
                        <Input type={"number"} />
                    </Form.Item>
                    <Form.Item
                        label={t('users.maxAmount')}
                        name="maxAmount"
                        rules={[{ required: true, message: t('users.maxAmountRequired') }]}
                        initialValue={1000000}
                    >
                        <Input type={"number"} />
                    </Form.Item>
                    <Form.Item>
                        <Button type="primary" htmlType="submit">
                            {t('users.addButton')}
                        </Button>
                        <Button style={{ marginLeft: 8 }} onClick={handleCancel}>
                            {t('users.cancel')}
                        </Button>
                    </Form.Item>
                </Form>
            </Modal>
        </div>
    );
};

export default Users;